import React from "react";
import FrontendLayout from "../FrontendLayout";
import Hero from "../front-components/Hero";
import { ORG } from "../../data/costant";

export default function RefundPolicy() {
  return (
    <FrontendLayout>
      <Hero title="Refund, Return & Cancellation Policy" />
      <div className="container my-5">
        <div className="card">
          <div className="card-body">
            <h6>General Terms</h6>
            <p>
              <strong>Non-Refundable Transactions:</strong> Once a value is debited from your payment instrument or bank account
              and credited to your Nexways.in ID, the transaction is deemed final, and no cancellation or refund is permitted.
            </p>
            <p>
              <strong>Refunds for Undelivered Value:</strong> If an amount is charged to your payment instrument or bank account
              and the corresponding value is not delivered within <strong>24 hours</strong>, please notify us via email at
              <strong> {ORG.email}</strong>.
            </p>
            <p>
              Provide the following details in your email:
            </p>
            <ul>
              <li>Transaction value</li>
              <li>Transaction date</li>
              <li>Order number</li>
            </ul>
            <p>
              Upon investigation, if it is confirmed that the payment was processed without value delivery, the amount will be refunded to
              the original payment method within <strong>15 working days</strong>.
            </p>

            <h6>Cancellations</h6>
            <p>
              <strong>Booking Cancellations:</strong> Customers may request cancellation of a booking by providing complete booking details
              via our customer care interface.
            </p>
            <p>
              <strong>Conditions for Cancellation:</strong>
            </p>
            <ul>
              <li>Once vendor, vehicle, and driver details are shared, the booking amount becomes non-refundable.</li>
              <li>
                If a cancellation request is accepted, a cancellation fee will apply, and refunds (if applicable) will be processed within
                <strong>15 days</strong> of approval.
              </li>
            </ul>
            <p>
              <strong>Non-Cancellable Bookings:</strong> If the transportation vehicle has already been dispatched, cancellation will not
              be permitted, and no refund will be issued.
            </p>
            <p>
              In cases where a vehicle arrives at the client location but experiences loading delays, waiting charges ranging from
              <strong>₹1,000 to ₹5,000 per day</strong> (depending on vehicle type) will apply. If the vehicle returns empty due to non-loading,
              customers will be required to pay fuel charges.
            </p>

            <h6>Returns and Refunds</h6>
            <p>
              <strong>Terms for Returns:</strong> Requests for returns or refunds must be initiated within <strong>15 days</strong> of the
              transaction or service. Refund eligibility will be subject to review and compliance with policy conditions.
            </p>
            <p>
              <strong>Refund Process:</strong> Approved refunds will be credited to the original payment instrument within
              <strong>15 days</strong> of confirmation. Refunds will only be processed for valid cases, such as service deficiencies or errors on our end.
            </p>

            <h6>Customer Responsibilities</h6>
            <p>
              Customers agree not to dispute payments with payment repositories or service providers unless explicitly stated in this policy.
              By using our services, you authorize Nexways.in to handle disputes directly with payment service providers if necessary,
              in alignment with these terms.
            </p>

            <h6>Contact Information</h6>
            <p>
              For queries related to refunds or cancellations, reach out to us at:
            </p>
            <p>
              <strong>Phone:</strong> +91 {ORG.mobile}<br />
              <strong>Email:</strong> {ORG.email}
            </p>

            <h6>Policy Updates</h6>
            <p>
              We reserve the right to update or modify this policy at any time. Please review the latest version on our website for the most accurate
              information.
            </p>
          </div>
        </div>
      </div>
    </FrontendLayout>
  );
}
